import { format } from 'date-fns';

// The booking time as the wall-clock value the renter picked, with no timezone
// ("2026-10-02T10:00"). The backend reads it in the fleet's timezone, so "10 AM"
// means 10 AM at the fleet whatever timezone this browser is in. toISOString()
// would instead bake in the browser's offset.
export const toFleetWallClock = (date) => format(date, "yyyy-MM-dd'T'HH:mm");
